import { useState } from "react";
import { api } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", form);
      toast.success("Thanks! Our team will be in touch shortly.");
      setForm({ name: "", email: "", phone: "", subject: "General", message: "" });
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <PageHero title="Get in touch" subtitle="Tailor-made travel? Group bookings? Our experts are here to help." image="https://images.unsplash.com/photo-1436491865332-7a61a109cc05" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-10 lg:grid-cols-3">
        <div className="lg:col-span-1 space-y-5">
          <h2 className="font-display text-2xl font-bold text-slate-900">Elia Travel &amp; Tours Ltd</h2>
          <p className="text-slate-600 text-sm">Speak to a travel specialist for bespoke quotes on flights, holidays and Umrah packages.</p>
          <div className="space-y-3 text-sm text-slate-700">
            <p className="flex gap-2"><MapPin className="w-5 h-5 text-[#FF6B35]" /> Unit 6a, 802-804 Stratford Road, Sparkhill, Birmingham, B11 4BS</p>
            <p className="flex gap-2"><Phone className="w-5 h-5 text-[#FF6B35]" /> 020 4615 3141</p>
            <p className="flex gap-2"><Mail className="w-5 h-5 text-[#FF6B35]" /> info@eliatravelandtours.co.uk</p>
          </div>
        </div>
        <form onSubmit={submit} className="lg:col-span-2 bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label>Full name</Label><Input data-testid="enquiry-name" required value={form.name} onChange={(e) => set("name", e.target.value)} /></div>
            <div><Label>Email</Label><Input data-testid="enquiry-email" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} /></div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label>Phone</Label><Input data-testid="enquiry-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} /></div>
            <div><Label>Subject</Label>
              <select data-testid="enquiry-subject" value={form.subject} onChange={(e) => set("subject", e.target.value)} className="w-full rounded-md border border-input px-3 py-2 text-sm bg-white h-10">
                <option>General</option><option>Flights</option><option>Holidays</option><option>Umrah & Hajj</option><option>Group Booking</option>
              </select>
            </div>
          </div>
          <div><Label>Message</Label><Textarea data-testid="enquiry-message" required rows={5} value={form.message} onChange={(e) => set("message", e.target.value)} placeholder="Tell us where you'd like to go, dates and number of travellers…" /></div>
          <Button data-testid="enquiry-submit" type="submit" disabled={loading} className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold px-8 py-6">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Enquiry"}
          </Button>
        </form>
      </div>
    </div>
  );
}
